import { api } from '~/shared/api';

export const getLookups = async () => await api.get('/configuration/').catch((e) => console.warn(e));
